@import 'styles/mixins';
@import 'styles/variables';

@include for-phone-only {
  .gaugeContainer {
    width: 100%;
  }
}

.gaugeContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  background-color: var(--light-60);
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
  margin: 2px 8px 9px 8px;

  [data-autopilot-system-redesign='on'] & {
    box-shadow: none;
    border: none;
    border-radius: 0;
    margin: 0;
  }
}

.scoreTextContent {
  display: flex;
  flex-direction: column;
  margin-bottom: -5px;
}

.red {
  transform: translate(15px, 33px);
}

.yellow {
  transform: translate(73px, 13px);
}

.green {
  transform: translate(198px, 33px);
}

.pointer {
  transition: transform 0.3s ease;
}

.scoreText {
  position: absolute;
  text-align: center;
  left: 50%;
  bottom: 17px;
  transform: translateX(-50%);
  width: 160px;

  :first-child {
    margin-bottom: 2px;
  }
}

.zero {
  position: absolute;
  left: 30px;
  bottom: 12px;
}

.hundred {
  position: absolute;
  right: 30px;
  bottom: 12px;
}
